import { useEffect, useState } from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { getTipoTramites } from '../../services/tipoTramiteService';
import { crearCobro } from '../../services/cobranzaService';
import { colorPrimarioTramite } from '../Documentos/coloresTramite';

const COLOR = colorPrimarioTramite('cobro');

/**
 * Alta manual de un cobro desde la ficha del cliente — el único lugar desde donde se puede crear
 * un cobro sin trámite (ver "Acceso a la ficha del cobro" en la spec del módulo). El tipo de
 * trámite es opcional: alcanza con el cliente para empezar a hacerle seguimiento de cobranza.
 */
export default function ModalNuevoCobro({ open, cuil, onClose, onCreado }) {
    const [tipos, setTipos] = useState([]);
    const [idTipoTramite, setIdTipoTramite] = useState('');
    const [detalle, setDetalle] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (open) {
            setIdTipoTramite('');
            setDetalle('');
            getTipoTramites().then((t) => setTipos(Array.isArray(t) ? t : [])).catch(() => setTipos([]));
        }
    }, [open]);

    const handleGuardar = async () => {
        setGuardando(true);
        try {
            const dto = { cuil };
            if (idTipoTramite) {
                dto.tramites = [{ idTipoTramite, detalle: detalle?.trim() || null }];
            }
            await crearCobro(dto);
            toast.success('Cobro creado.');
            onCreado?.();
            onClose?.();
        } catch (err) {
            toast.error(err.response?.data?.mensaje || 'No se pudo crear el cobro.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflowY: 'auto' } }}>
            <Box sx={{ background: `${COLOR}12`, borderBottom: `1px solid ${COLOR}33`, px: 3, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                <span className="fw-bold" style={{ color: '#1e293b', fontSize: '1.05rem' }}>
                    <i className="bi bi-plus-circle me-2" style={{ color: COLOR }}></i>Nuevo cobro
                </span>
                <IconButton onClick={onClose} size="small"><CloseIcon fontSize="small" /></IconButton>
            </Box>
            {/* El papel del diálogo tiene overflow hidden: sin scroll propio, lo que no entra en una pantalla baja se corta. */}
            <Box sx={{ p: 3, overflowY: 'auto' }}>
                <div className="mb-1">
                    <label className="form-label fw-semibold">Tipo de trámite (opcional)</label>
                    <select className="form-select" value={idTipoTramite} onChange={(e) => setIdTipoTramite(e.target.value)}>
                        <option value="">Sin trámite todavía</option>
                        {tipos.map((t) => <option key={t.idTipoTramite} value={t.idTipoTramite}>{t.nombre}</option>)}
                    </select>
                    <div className="form-text">Si todavía no existe la carpeta, se puede dejar sin elegir y engancharla después.</div>
                </div>
                {idTipoTramite && (
                    <div className="mb-3 mt-2">
                        <label className="form-label fw-semibold">Detalle (opcional)</label>
                        <input type="text" className="form-control" value={detalle} onChange={(e) => setDetalle(e.target.value)} />
                    </div>
                )}
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <button className="btn btn-outline-secondary rounded-pill px-4" onClick={onClose} disabled={guardando}>Cancelar</button>
                    <button className="btn rounded-pill px-4 fw-semibold text-white" style={{ background: COLOR, borderColor: COLOR }} onClick={handleGuardar} disabled={guardando}>
                        {guardando ? <span className="spinner-border spinner-border-sm" /> : 'Crear'}
                    </button>
                </div>
            </Box>
        </Dialog>
    );
}
